<template>
  <v-select
    solo
    label="Select language"
    v-model="lang"
    :items="languages"
    hide-details
    :disabled="disabled"
  ></v-select>
</template>

<script>
export default {
  props: ['value', 'disabled'],
  data () {
    return {
      lang: 'en',
      languages: [{
        text: 'Dansk',
        value: 'da'
      }, {
        text: 'English',
        value: 'en'
      }, {
        text: 'Swedish',
        value: 'sv'
      }, {
        text: 'Norsk',
        value: 'nb'
      }]
    }
  },
  watch: {
    value: {
      handler (val) {
        this.lang = val
      }
    },
    lang: {
      handler (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
